<template>
  <div class="container faq">
    <h2>FAQ</h2>
    <v-expansion-panels>
      <v-expansion-panel
        class="faq-pannel"
        v-for="(question, index) in faqs"
        v-bind:key="'faq-' + index"
      >
        <v-expansion-panel-title
            collapse-icon="mdi-minus" expand-icon="mdi-plus"
          ><h3>{{ question.title }}</h3></v-expansion-panel-title
        >
        <v-expansion-panel-text
          ><div v-html="question.text"></div
        ></v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
export default {
  name: "FreemiumFaq",
  data() {
    return {
      faqs: null,
    };
  },
  created() {
    this.faqs = [
      {
        title: "Can I Stream Live TV for Free?",
        text: `
          <p>You can watch free live TV on a variety of streaming services. Platforms such as FlixLatino offer
          free streaming options with a wide selection of channels in Spanish at no cost to you. FlixLatino
          is accessible through mobile devices, SmartTVs, media players, and more. You can access the most
          popular free Spanish-language channels by streaming free live TV on FlixLatino.</p>
        `,
      },
      {
        title: "How Can I Watch Live TV for Free?",
        text: `
          <p>Streaming live TV for free in Spanish is super simple with FlixLatino. Sign up to FlixLatino and start
          watching free live TV today. Just follow these simple steps:</p>
          <ol>
            <li>Visit <a href="https://flixlatino.com/register">this page</a> to register to FlixLatino</li>
            <li>After creating your account, select the free plan</li>
            <li>You will be redirected to FlixLatino channels shortly after</li>
            <li>Surf and discover your new favorite Spanish-language channel</li>
          </ol>
          <p>For the best experience, download FlixLatino. FlixLatino is available on iOS and Android mobile
          devices as well as Roku, FireOS, GoogleTV, and Apple TV.</p>
        `,
      },
      {
        title: "Where Can I Watch Live TV for Free?",
        text: `<p>Watch free TV on your Mobile Device, SmartTV, Media Player, or desktop computer with FlixLatino
          Channels. Just download FlixLatino on your favorite device. FlixLatino Channels is free to everyone in
          the United States or Puerto Rico.</p>
        `,
      },
      {
        title: "Can I Watch Local Channels?",
        text: `<p>You can watch movies, series, news, sports and more on FlixLatino Channels.
          While you can watch live TV for free, local channels are not available on
          FlixLatino channels at this time.</p>
        `,
      },
      {
        title: "Is FlixLatino Really Free?",
        text: `<p>FlixLatino Channels is 100% free to watch. Stream live TV with FlixLatino channels by simply
          registering for an account. If you want to watch premium on-demand content, you may upgrade to a
          FlixLatino Basic or FlixLatino Premium plan to enjoy thousands of hours of premium Spanish-language
          entertainment.</p>
        `,
      },
      {
        title: "What’s Included in the Free Plan?",
        text: `
          <p>FlixLatino’s Free Plan includes a wide selection of free live TV channels. From classic Spanish-language
          movies to thrilling horror movies to your favorite telenovelas to news and sports, there is something
          available to watch for free on FlixLatino live TV channels.</p>
          <p>Among them you will find:</p>
          <ul>
            <li>Cine en Español: Classic Spanish-language movies for all tastes</li>
            <li>Cine de Horror: Horror movies in Spanish</li>
            <li>Azteca Internacional: TV Azteca’s flagship international channel which covers entertainment, news, reality, telenovelas, and series</li>
            <li>Azteca Deportes Network: Includes in the Saudi football league, the Swedish Allsvanskan league,
            the Copa Libertadores Femenina, BKFC (Bare Knuckle Fighting Championship), LUX (Fight League),
            Crossfit, Edge Sports, Track & Field and Sail GP</li>
            <li>ADN40: Mexican and world live news</li>
            <li>Vive Kanal D: Turkish dramas that have been curated for Spanish-speaking audiences</li>
            <li>Caracol Mix: Offers a wide selection of Caracol’s Colombian titles</li>
          </ul>
          <p>and much more!</p>
        `,
      },
    ];

    if (this.$i18n.locale === "es") {
      this.faqs = [
        {
          title: "¿Puedo transmitir TV en vivo gratis?",
          text: `
          <p>
            Puedes ver televisión en vivo gratis en una variedad de servicios de transmisión.
            Plataformas como FlixLatino ofrecen opciones de streaming gratis con una amplia selección de
            canales en español sin costo para ti. Puedes acceder a FlixLatino a través de dispositivos móviles,
            SmartTV, reproductores multimedia y más. Puedes ver los canales gratuitos en español más
            populares transmitiendo TV en vivo gratis en FlixLatino.
          </p>
        `,
        },
        {
          title: "¿Cómo puedo ver televisión en vivo gratis?",
          text: `
          <p>Transmitir TV en vivo gratis en español es súper sencillo con FlixLatino. Regístrate en FlixLatino y
          comienza a ver televisión en vivo gratis hoy. Simplemente sigue estos sencillos pasos:</p>
          <ol>
            <li>Visita <a href="https://flixlatino.com/es/registro">esta página</a> para registrarte en FlixLatino</li>
            <li>Después de crear tu cuenta, selecciona el plan gratuito</li>
            <li>Serás redirigido a los canales de FlixLatino poco después.</li>
            <li>Navega y descubre tu nuevo canal favorito en español</li>
          </ol>
          <p>Para la mejor experiencia, descarga FlixLatino. FlixLatino está disponible en
          dispositivos móviles iOS y Android, así como en Roku, FireOS, GoogleTV y Apple TV</p>
        `,
        },
        {
          title: "¿Dónde puedo ver televisión en vivo gratis?",
          text: `<p>Mire televisión gratis en tu dispositivo móvil, SmartTV, Media Player o computadora con los
            canales de FlixLatino. Simplemente descarga FlixLatino en tu dispositivo favorito. FlixLatino Channels es
            gratuito para todos en los Estados Unidos o Puerto Rico.</p>
        `,
        },
        {
          title: "¿Puedo ver canales locales?",
          text: `<p>Puedes ver películas, series, noticias, deportes y más en los Canales de FlixLatino. Si bien
            puedes ver televisión en vivo de forma gratuita, los canales locales no están disponibles en los canales de
            FlixLatino en este momento.</p>
        `,
        },
        {
          title: "¿FlixLatino es realmente gratis?",
          text: `<p>FlixLatino Channels es 100% gratuito para ver. Transmite TV en vivo con canales FlixLatino
            simplemente registrándote para obtener una cuenta. Si deseas ver el contenido premium, puedes actualizar a un plan
            FlixLatino Basic o FlixLatino Premium para disfrutar de miles de horas de entretenimiento premium en español.</p>
        `,
        },
        {
          title: "¿Qué está incluido en el plan gratuito?",
          text: `
          <p>El Plan Gratis de FlixLatino incluye una amplia selección de canales de TV en vivo gratuitos. Desde
          películas clásicas en español hasta emocionantes películas de terror, pasando por tus telenovelas favoritas,
          noticias y deportes, hay algo disponible para ver gratis en los canales de televisión en vivo de FlixLatino.
          </p>
          <ul>
            <li>Cine en Español: Películas clásicas en español para todos los gustos</li>
            <li>Cine de Terror: Películas de terror en español</li>
            <li>Azteca Internacional: el canal internacional insignia de TV Azteca que cubre entretenimiento, noticias, reality, telenovelas y series.</li>
            <li>Azteca Deportes Network: Incluye en la liga de fútbol saudita, la liga sueca Allsvanskan, la Copa Libertadores Femenina, BKFC (Bare Knuckle Fighting Championship), LUX (Fight League), Crossfit, Edge Sports, Track & Field y Sail GP.</li>
            <li>ADN40: noticias en vivo de México y el mundo</li>
            <li>Vive Kanal D: dramas turcos curados para audiencias de habla hispana</li>
            <li>Caracol Mix: Ofrece una amplia selección de títulos colombianos de Caracol</li>
          </ul>
          <p>y mucho más</p>
        `,
        },
      ];
    }
  },
  computed: {},
};
</script>

<style lang="scss">
@import "src/assets/scss/colors";

.faq {
  ol li {
    list-style: decimal inside !important;
    padding-left: 10px;
  }

  ul li {
    list-style: circle inside !important;
    padding-left: 10px;
    text-indent: -20px;
  }
  li {
    margin: 5px auto 5px auto;
  }
  h2 {
    margin: 1rem auto 3rem auto;
    font-size: 68px;
    font-weight: 700;
    line-height: 84px;
  }
  margin-bottom: 1.5em;
  text-align: center;
  .faq-pannel {
    border: 1px solid $washed-white;
    background: #131a29;
    backdrop-filter: blur(16px);
    margin-bottom: 0.5em;
    border-radius: 14px !important;
    &.v-expansion-panel,
    &.v-expansion-panel--active,
    &.v-expansion-panel--before-active,
    &.v-expansion-panel--after-active {
    }
    button.v-expansion-panel-title {
      border-radius: 14px;
      & > h3 {
        font-size: 1.5rem !important;
      }
      &:hover {
        .v-expansion-panel-title__overlay {
          background: $washed-white;
        }
      }
      &.v-expansion-panel-title--active {
        .v-expansion-panel-title__overlay {
          background: $washed-white;
          border-bottom-right-radius: 0;
          border-bottom-left-radius: 0;
        }
      }
    }
  }
  .v-expansion-panel-text__wrapper {
    text-align: left;
  }
  .v-expansion-panel--active > .v-expansion-panel-title {
    min-height: auto;
  }
  .v-expansion-panels,
  .v-expansion-panels:not(.v-expansion-panels--variant-accordion)
    > :not(:first-child):not(:last-child):not(.v-expansion-panel--active):not(
      .v-expansion-panel--before-active
    ),
  .v-expansion-panels:not(.v-expansion-panels--variant-accordion)
    > :not(:first-child):not(:last-child):not(.v-expansion-panel--active):not(
      .v-expansion-panel--after-active
    ),
  .v-expansion-panels:not(.v-expansion-panels--variant-accordion)
    > :first-child:not(:last-child):not(.v-expansion-panel--active):not(
      .v-expansion-panel--before-active
    ),
  .v-expansion-panels:not(.v-expansion-panels--variant-accordion)
    > :last-child:not(:first-child):not(.v-expansion-panel--active):not(
      .v-expansion-panel--after-active
    ) {
    border-radius: 14px !important;
  }
}
</style>
